<template>
  <div>
    <LaunchpadMainSection />
    <CCWebVid />
    <LaunchpadRoadmap />
    <LaunchpadStorefrontDesign />
    <LaunchpadInspiration />
    <LaunchpadSKUs />
    <LaunchpadMerchHandling />
    <LaunchpadTimeline />
    <LaunchpadLaunch />
    <!-- <LaunchpadSupport /> -->
    <LaunchpadBiggestCreators />
    <MainCCFooter />
  </div>
</template>

<script>
import LaunchpadBiggestCreators from '@/components/LaunchpadBiggestCreators.vue';
import LaunchpadLaunch from '@/components/LaunchpadLaunch.vue';
import LaunchpadMerchHandling from '@/components/LaunchpadMerchHandling.vue';
// import LaunchpadSupport from '@/components/LaunchpadSupport.vue';
import CCWebVid from '@/components/CCWebVid.vue';
import LaunchpadInspiration from '@/components/LaunchpadInspiration.vue';
import LaunchpadMainSection from '@/components/LaunchpadMainSection.vue';
import LaunchpadRoadmap from '@/components/LaunchpadRoadmap.vue';
import LaunchpadSKUs from '@/components/LaunchpadSKUs.vue';
import LaunchpadStorefrontDesign from '@/components/LaunchpadStorefrontDesign.vue';
import LaunchpadTimeline from '@/components/LaunchpadTimeline.vue';
import MainCCFooter from '@/components/MainCCFooter.vue';
import { buildPageMeta } from '@/utils/meta';
import { useHead } from '@vueuse/head';

export default {
  name: 'LaunchPad',

  components: {
    MainCCFooter,
    LaunchpadMainSection,
    CCWebVid,
    LaunchpadStorefrontDesign,
    LaunchpadInspiration,
    LaunchpadSKUs,
    LaunchpadTimeline,
    // LaunchpadSupport,
    LaunchpadRoadmap,
    LaunchpadMerchHandling,
    LaunchpadLaunch,
    LaunchpadBiggestCreators,
  },

  setup() {
    useHead(
      buildPageMeta({
        title: 'Launch Pad | Ecommerce Technology for Creators & Communities',
        description:
          'Select option that is the best fit for your business needs. HelixPay Checkout is custom built for subscriptions and recurring payments.',
        url: 'https://www.helixpay.ph/launchpad',
        image: 'https://www.helixpay.ph/img/Website-Illustration.png',
      })
    );
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  line-height: 2;
  box-sizing: border-box;
}

body {
  font-size: 1.1rem;
  line-height: 2;
}
</style>
